import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fromJS } from 'immutable';
import moment from 'moment';
import CallRecordsResource from 'flow/api/callrecords';
import ConferencesResource from 'flow/api/conferences';
import QueuesResource from 'flow/api/queues';
import RefersResource from 'flow/api/refers';
import SharedExtensionResource from 'flow/api/sharedextension';
import VoicemailsResource from 'flow/api/voicemails';
import Actions from 'flow/actions';
import { selectPbxPageIsMounted } from 'flow/selectors/app-selectors';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { selectQueueCallRecordIsFinished, selectQueueCallRecordsActive } from 'flow/selectors/call-records-selectors';
import { getQueueCallRecordsNextSince, selectQueueCallRecordsNextBefore, selectQueueCallRecordsWithBPartNextBefore, selectQueueMembers } from 'flow/selectors/queue-selectors';
import { ISO_8601_MS_RESOLUTION } from 'flow/utils';
import { addHomeLogEntry } from 'flow/utils/browser-utils';
import { getEarliestConnectedCallRecord } from 'flow/utils/call-records-utils';
import { CALL_RECORD_INCLUDES_DETAIL, CALL_RECORD_INCLUDES_LIST } from 'flow/utils/call-record-fetch-includes';
import { httpGetErrorDispatcher, networkErrorDispatcher, spawnVoiceMessageNotification } from './app-actions';
import { fetchWidgetChannels } from './channels-actions';
var appFilter = 'desktop';
var createCallback = function createCallback(dispatch, cbFunc) {
  return {
    onResult: function onResult(json) {
      dispatch(cbFunc(json));
    },
    onError: httpGetErrorDispatcher(dispatch)
  };
};
export var fetchQueue = function fetchQueue(queueKey) {
  return function (dispatch) {
    QueuesResource.getQueue({
      onResult: function onResult(json) {
        dispatch(receiveQueue(queueKey, json));
      },
      onError: httpGetErrorDispatcher(dispatch)
    }, queueKey, 'all,contact', appFilter);
  };
};
export var fetchQueueWithContact = function fetchQueueWithContact(queueKey) {
  return function (dispatch) {
    QueuesResource.getQueue({
      onResult: function onResult(json) {
        dispatch(receiveQueue(queueKey, json));
      },
      onError: httpGetErrorDispatcher(dispatch)
    }, queueKey, 'contact', appFilter);
  };
};
export var fetchQueueCalendar = function fetchQueueCalendar(queueKey) {
  return function (dispatch) {
    QueuesResource.getCalendar({
      onResult: function onResult(json) {
        dispatch(receiveQueueCalendar(queueKey, json));
      },
      onError: httpGetErrorDispatcher(dispatch)
    }, queueKey);
  };
};
export var fetchQueueCallRecords = function fetchQueueCallRecords(queueEntityKey, before, since, include) {
  var useErrorDispatcher = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var otherPart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return function (dispatch) {
    var otherPartNumberApiRequestFriendly = otherPart ? getBPartNumberApiRequestFriendly(otherPart) : null;
    return new Promise(function (resolve, reject) {
      CallRecordsResource.getQueueCallRecords({
        onResult: function onResult(json) {
          if (otherPart) {
            dispatch(receiveQueueCallRecordsWithBPart(queueEntityKey, otherPart, json, include));
          } else {
            dispatch(receiveQueueCallRecords(queueEntityKey, json, include));
          }
          resolve(json);
        },
        onError: function onError(error) {
          if (useErrorDispatcher) {
            httpGetErrorDispatcher(dispatch)(error);
          }
          reject(error);
        },
        onClientError: function onClientError(error) {
          reject(error);
        }
      }, queueEntityKey, before, since, otherPartNumberApiRequestFriendly, include);
    });
  };
};
var getBPartNumberApiRequestFriendly = function getBPartNumberApiRequestFriendly(number) {
  if (!number) return number;
  if (number.startsWith('+46')) {
    return number.replace('+46', '0');
  }
  if (number.startsWith('+')) {
    return number.replace('+', '00');
  }
  return number;
};
export var fetchQueueCallRecordsWithBPart = function fetchQueueCallRecordsWithBPart(queueEntityKey, bPartNumber) {
  var useBeforeArgument = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch, getState) {
    var beforeArgument = useBeforeArgument ? selectQueueCallRecordsWithBPartNextBefore(getState(), queueEntityKey, bPartNumber) : null;
    return dispatch(fetchQueueCallRecords(queueEntityKey, beforeArgument, null, CALL_RECORD_INCLUDES_DETAIL, true, bPartNumber))["catch"](function (error) {
      return console.error("Could not fetch call records with bPart ".concat(bPartNumber, " for queue ").concat(queueEntityKey, " error: ").concat(error));
    });
  };
};
export var fetchOlderQueueCallRecords = function fetchOlderQueueCallRecords(queueEntityKey) {
  return function (dispatch, getState) {
    var nextBefore = selectQueueCallRecordsNextBefore(getState(), queueEntityKey);
    return dispatch(fetchQueueCallRecords(queueEntityKey, nextBefore, null, CALL_RECORD_INCLUDES_LIST))["catch"](function () {
      return console.error("Could not fetch call records for queue ".concat(queueEntityKey));
    });
  };
};

// `coverFromMilliseconds` says exactly how far back this fetch has to reach, and
// wins over the anchors below when the caller knows it. Those anchors -- the calls
// we hold as ongoing, else the API's cursor -- know nothing about a call we have
// never seen: the cursor sits one millisecond after the newest call we do know
// about, so a call that started before it can't be reached again. That normally
// can't happen -- a call still running when we fetched is kept as ongoing and
// drags the anchor back behind itself -- but the call log is written per writer
// queue and a queue's calls can be spread across SIP servers, so a later call can
// become visible before an earlier one and move the cursor past it. Asking from a
// known point also keeps the window off the oldest call still ringing or talking,
// which on a busy queue can sit a long way back.
export var fetchNewerQueueCallRecords = function fetchNewerQueueCallRecords(queueEntityKey, coverFromMilliseconds) {
  return function (dispatch, getState) {
    var activeCallRecords = selectQueueCallRecordsActive(getState(), queueEntityKey);
    var earliestConnected = getEarliestConnectedCallRecord(activeCallRecords);
    var anchoredSince = earliestConnected && moment(earliestConnected).subtract(1, 'seconds').format('x') || getQueueCallRecordsNextSince(getState(), queueEntityKey);
    var since = coverFromMilliseconds !== null && coverFromMilliseconds !== void 0 ? coverFromMilliseconds : anchoredSince;
    return dispatch(fetchQueueCallRecords(queueEntityKey, null, since, CALL_RECORD_INCLUDES_LIST))["catch"](function () {
      return console.error("Could not fetch call records for queue ".concat(queueEntityKey));
    });
  };
};

// Fetches one call record straight into the queue's history. Needs no time window,
// unlike the list endpoint, which can only be asked for calls that *started* within
// one -- so picking up a call that has just ended means asking for everything back
// to when that call started, however long it ran.
export var fetchQueueCallRecord = function fetchQueueCallRecord(queueEntityKey, callRecordKey) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      CallRecordsResource.getCallRecord({
        onResult: function onResult(json) {
          dispatch({
            type: Actions.RESULT_CALL_RECORD_FOR_SCOPE,
            scope: {
              type: 'queue',
              key: queueEntityKey
            },
            callRecordKey: callRecordKey,
            data: json,
            include: CALL_RECORD_INCLUDES_LIST
          });
          resolve(json);
        },
        // The record only exists once the call log has been written, so
        // a miss is expected and the caller simply asks again.
        onError: function onError() {
          return resolve();
        },
        onClientError: function onClientError() {
          return resolve();
        }
      }, callRecordKey, CALL_RECORD_INCLUDES_LIST);
    });
  };
};
var delay = function delay(milliseconds) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, milliseconds);
  });
};

// The history list only shows call records the API reports as finished; a record
// without a `disconnected` is an ongoing call and belongs in the active section
// above it. That distinction is written asynchronously: top hands the call's
// hangup to a background writer of the call log and pushes the hangup event to us
// without waiting for it, so a fetch made the moment we learn the call ended can
// still get the record back as ongoing. It was then stored as an ongoing call and
// stayed out of the history until some unrelated later fetch happened to cover it
// again -- in practice when the next call was answered (AC-1508).
//
// So the fetch on hangup can't be a single shot: ask once more, shortly after. One
// ask is enough because that writer is a serial queue -- either it is keeping up,
// and the write lands within milliseconds of us being a beat early, or it is backed
// up, and no wait we would be willing to make covers it. A record still ongoing
// beyond that usually means a call that hasn't ended at all: a blind transfer hangs
// up the agent's channel while the call carries on with someone else.
var ENDED_QUEUE_CALL_SECOND_ASK_DELAY_MILLISECONDS = 500;

// The join time we know a queue call by comes from top in whole seconds and is not
// the same clock reading as the start the API reports the record's `connected`
// from, so give the window some room rather than trusting the two to line up.
var QUEUE_JOIN_TIME_MARGIN_SECONDS = 15;

// Past this many of a queue's calls being followed to their record at once, calls
// are ending faster than following them one by one can keep up -- a queue being
// emptied, or stuck calls being cleaned up. Following each would mean a fetch per
// call, and none of them can succeed for a call whose record was never finished.
var MAX_QUEUE_CALLS_FOLLOWED_AT_ONCE = 3;

// Which of a queue's calls are being followed, so that the same call reported twice
// doesn't start a second attempt, and so we can tell when there are too many.
var callRecordsBeingFollowed = new Map();

// Queues with a catch-up fetch in flight, so that calls we aren't following one by
// one ask for one window between them rather than one each.
var queuesBeingCaughtUp = new Set();

/**
 * Brings the queue's history up to date after one of its calls ended.
 *
 * `callRecordKey` is the record the ended call will show up as, when we know it.
 * Without it (queue items that carry no locutus session, e.g. omni errands) there
 * is nothing to wait for, so the queue is simply caught up on.
 *
 * `queueJoinTime` is when that call entered the queue, and makes every fetch
 * reach far enough back to include it instead of relying on where the API's
 * cursor happens to sit.
 */
export var onQueueCallEnded = function onQueueCallEnded(queueEntityKey, callRecordKey, queueJoinTime) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _callRecordsBeingFoll;
      var historyIsOnScreen, recordHasLanded, coverFromMilliseconds, fetchHistory, catchUpOnQueueHistory, beingFollowed;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            historyIsOnScreen = function historyIsOnScreen() {
              return selectPbxPageIsMounted(getState(), queueEntityKey);
            };
            recordHasLanded = function recordHasLanded() {
              return selectQueueCallRecordIsFinished(getState(), queueEntityKey, callRecordKey);
            };
            coverFromMilliseconds = queueJoinTime ? moment(queueJoinTime).subtract(QUEUE_JOIN_TIME_MARGIN_SECONDS, 'seconds').valueOf() : undefined; // Ask for the one record when we know which it is; otherwise fall back to a
            // window reaching back to when the call joined the queue.
            fetchHistory = function fetchHistory() {
              return callRecordKey ? dispatch(fetchQueueCallRecord(queueEntityKey, callRecordKey)) : dispatch(fetchNewerQueueCallRecords(queueEntityKey, coverFromMilliseconds));
            }; // Asks for whatever the queue has gained, covering every call that ended
            // around now rather than one of them. Coalesced, so a flood of endings asks
            // once between them instead of once each.
            catchUpOnQueueHistory = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(coverFrom) {
                return _regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!queuesBeingCaughtUp.has(queueEntityKey)) {
                        _context.next = 1;
                        break;
                      }
                      return _context.abrupt("return");
                    case 1:
                      queuesBeingCaughtUp.add(queueEntityKey);
                      _context.prev = 2;
                      _context.next = 3;
                      return dispatch(fetchNewerQueueCallRecords(queueEntityKey, coverFrom));
                    case 3:
                      _context.prev = 3;
                      queuesBeingCaughtUp["delete"](queueEntityKey);
                      return _context.finish(3);
                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[2,, 3, 4]]);
              }));
              return function catchUpOnQueueHistory(_x3) {
                return _ref2.apply(this, arguments);
              };
            }();
            if (historyIsOnScreen()) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            if (callRecordKey) {
              _context2.next = 3;
              break;
            }
            _context2.next = 2;
            return catchUpOnQueueHistory(coverFromMilliseconds);
          case 2:
            return _context2.abrupt("return");
          case 3:
            if (!recordHasLanded()) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            beingFollowed = (_callRecordsBeingFoll = callRecordsBeingFollowed.get(queueEntityKey)) !== null && _callRecordsBeingFoll !== void 0 ? _callRecordsBeingFoll : new Set();
            if (!beingFollowed.has(callRecordKey)) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return");
          case 5:
            if (!(beingFollowed.size >= MAX_QUEUE_CALLS_FOLLOWED_AT_ONCE)) {
              _context2.next = 7;
              break;
            }
            _context2.next = 6;
            return catchUpOnQueueHistory();
          case 6:
            return _context2.abrupt("return");
          case 7:
            beingFollowed.add(callRecordKey);
            callRecordsBeingFollowed.set(queueEntityKey, beingFollowed);
            _context2.prev = 8;
            _context2.next = 9;
            return fetchHistory();
          case 9:
            if (!(recordHasLanded() || !historyIsOnScreen())) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("return");
          case 10:
            _context2.next = 11;
            return delay(ENDED_QUEUE_CALL_SECOND_ASK_DELAY_MILLISECONDS);
          case 11:
            if (historyIsOnScreen()) {
              _context2.next = 12;
              break;
            }
            return _context2.abrupt("return");
          case 12:
            _context2.next = 13;
            return fetchHistory();
          case 13:
            // Logged rather than consoled so that it reaches the app log, which is
            // what we have to go on when this turns up as a customer report. Still
            // being ongoing is not necessarily wrong: a call transferred away
            // carries on after the channel we were watching hung up.
            if (recordHasLanded()) {
              addHomeLogEntry("Call record ".concat(callRecordKey, " of queue ").concat(queueEntityKey, " was only reported as finished on the second ask"));
            } else {
              addHomeLogEntry("Call record ".concat(callRecordKey, " of queue ").concat(queueEntityKey, " was still reported as ongoing on the second ask, so the queue's history is left without it for now"));
            }
          case 14:
            _context2.prev = 14;
            beingFollowed["delete"](callRecordKey);
            if (!beingFollowed.size) {
              callRecordsBeingFollowed["delete"](queueEntityKey);
            }
            return _context2.finish(14);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[8,, 14, 15]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var createCallRecordAction = function createCallRecordAction(callRecordEntityKey, queueEntityKey, agentExtensionDTO, bPartNumber) {
  return function (dispatch) {
    var callActionDTO = {
      agent: {
        key: agentExtensionDTO.get('key')
      },
      name: 'handle-unanswered',
      timestamp: moment().format(ISO_8601_MS_RESOLUTION)
    };
    var contactObject = fromJS(agentExtensionDTO.get('contact'));
    CallRecordsResource.createCallAction({
      onResult: function onResult(json) {
        json.agent.contact = contactObject;
        dispatch(receiveCreateCallAction(callRecordEntityKey, queueEntityKey, json, bPartNumber));
      },
      onError: networkErrorDispatcher(dispatch)
    }, callRecordEntityKey, callActionDTO);
  };
};
export var deleteCallRecordAction = function deleteCallRecordAction(callRecordEntityKey, callActionEntityKey, queueKey, bPartNumber) {
  return function (dispatch) {
    CallRecordsResource.deleteCallAction({
      onResult: function onResult() {
        dispatch(receiveDeleteCallAction(callRecordEntityKey, callActionEntityKey, queueKey, bPartNumber));
      },
      onError: networkErrorDispatcher(dispatch)
    }, callRecordEntityKey, callActionEntityKey);
  };
};
export var clearQueueCallRecords = function clearQueueCallRecords(queueEntityKey) {
  return {
    type: Actions.CLEAR_QUEUE_CALL_RECORDS,
    key: queueEntityKey
  };
};
export var clearQueueCallRecordsBPartSpecific = function clearQueueCallRecordsBPartSpecific(queueEntityKey, bPartNumber) {
  return {
    type: Actions.CLEAR_QUEUE_CALL_RECORDS_BPART_SPECIFIC,
    key: queueEntityKey,
    bPartNumber: bPartNumber
  };
};
var receiveQueueCallRecords = function receiveQueueCallRecords(queueKey, json, include) {
  return {
    type: Actions.RESULT_CALL_RECORDS_FETCHED,
    scope: {
      type: 'queue',
      key: queueKey
    },
    data: json,
    include: include
  };
};
var receiveQueueCallRecordsWithBPart = function receiveQueueCallRecordsWithBPart(queueKey, bPartNumber, json, include) {
  return {
    type: Actions.RESULT_CALL_RECORDS_FETCHED,
    scope: {
      type: 'queue',
      key: queueKey,
      phoneNumber: bPartNumber
    },
    data: json,
    include: include
  };
};
var receiveCreateCallAction = function receiveCreateCallAction(callRecordKey, queueKey, callActionDTO) {
  var bPartNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return {
    type: Actions.RESULT_CREATE_CALL_ACTION,
    callRecordKey: callRecordKey,
    queueKey: queueKey,
    bPartNumber: bPartNumber,
    data: callActionDTO
  };
};
var receiveDeleteCallAction = function receiveDeleteCallAction(callRecordKey, callActionKey, queueKey) {
  var bPartNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return {
    type: Actions.RESULT_DELETE_CALL_ACTION,
    callRecordKey: callRecordKey,
    callActionKey: callActionKey,
    queueKey: queueKey,
    bPartNumber: bPartNumber
  };
};
export var fetchQueueStatSummary = function fetchQueueStatSummary(queueKey, serviceLevels, resolution) {
  var errorCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : networkErrorDispatcher;
  return function (dispatch) {
    if (resolution === 'today') resolution = 'day';
    QueuesResource.getQueueStatSummary({
      onResult: function onResult(json) {
        dispatch(receiveQueueStatSummary(queueKey, json));
      },
      onError: errorCallback(dispatch)
    }, queueKey, serviceLevels, resolution);
  };
};
export var fetchAllowedQueueMembers = function fetchAllowedQueueMembers(queueKey) {
  return function (dispatch) {
    QueuesResource.getAllowedMembersForQueue({
      onResult: function onResult(json) {
        dispatch(receiveAllowedQueueMembers(queueKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueKey);
  };
};
export var activateQueueProfile = function activateQueueProfile(queueKey, profileDTO, callback) {
  return function (dispatch) {
    QueuesResource.setActiveProfile({
      onResult: function onResult(json) {
        dispatch(receiveQueueProfile(queueKey, json));
        if (callback) {
          callback();
        }
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueKey, profileDTO);
  };
};
export var fetchQueueActiveProfile = function fetchQueueActiveProfile(queueKey) {
  var errorCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : httpGetErrorDispatcher;
  return function (dispatch) {
    QueuesResource.getActiveProfile({
      onResult: function onResult(json) {
        dispatch(receiveQueueProfile(queueKey, json));
      },
      onError: errorCallback(dispatch)
    }, queueKey);
  };
};
export var updateQueue = function updateQueue(queueKey, queueDTO) {
  return function (dispatch) {
    var queue = _objectSpread(_objectSpread({}, queueDTO), {}, {
      key: queueKey
    });
    QueuesResource.updateQueue({
      onResult: function onResult(json) {
        dispatch(receiveQueue(queueKey, json));
      },
      onError: networkErrorDispatcher(dispatch),
      onClientError: function onClientError(error) {
        networkErrorDispatcher(dispatch)(error);
        dispatch(fetchQueueWithContact(queueKey));
      }
    }, queue);
  };
};
export var updateOwnQueueMemberLogin = function updateOwnQueueMemberLogin(queueKey, loginValue) {
  return function (dispatch, getState) {
    var _selectQueueMembers;
    var ownExtensionKey = selectOwnExtensionKey(getState());
    var queueMemberKey = (_selectQueueMembers = selectQueueMembers(getState(), queueKey)) === null || _selectQueueMembers === void 0 || (_selectQueueMembers = _selectQueueMembers.find(function (member) {
      return member.get('extensionKey') === ownExtensionKey;
    })) === null || _selectQueueMembers === void 0 ? void 0 : _selectQueueMembers.get('key');
    var memberDTO = fromJS({
      key: queueMemberKey,
      loggedIn: loginValue
    });
    dispatch(updateQueueMember(queueKey, memberDTO));
  };
};
export var updateQueueMember = function updateQueueMember(queueKey, queueMemberDTO) {
  return function (dispatch) {
    var queueMemberEntityKey = queueMemberDTO.get('key');
    QueuesResource.updateQueueMember({
      onResult: function onResult(json) {
        dispatch(receiveQueueMemberUpdate(queueKey, queueMemberEntityKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueKey, queueMemberEntityKey, queueMemberDTO);
  };
};
export var addQueueMembers = function addQueueMembers(queueKey, queueMemberDTOs) {
  return function (dispatch) {
    QueuesResource.addQueueMembers({
      onResult: function onResult(json) {
        dispatch(receiveAddQueueMembers(queueKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueKey, queueMemberDTOs);
  };
};
export var addQueueWaveMappings = function addQueueWaveMappings(queueKey, queueWaveKey, queueMemberDTOs) {
  return function (dispatch) {
    QueuesResource.addQueueWaveMappings({
      onResult: function onResult(json) {
        dispatch(receiveAddQueueWaveMappings(queueKey, queueWaveKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueKey, queueWaveKey, queueMemberDTOs);
  };
};
export var removeQueueMember = function removeQueueMember(queueEntityKey, queueMemberEntityKey) {
  return function (dispatch) {
    QueuesResource.removeQueueMember({
      onResult: function onResult(json) {
        dispatch(receiveRemoveQueueMember(queueEntityKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueEntityKey, queueMemberEntityKey);
  };
};
export var removeQueueWaveMapping = function removeQueueWaveMapping(queueEntityKey, queueWaveMapping) {
  return function (dispatch) {
    QueuesResource.removeQueueWaveMappings({
      onResult: function onResult(json) {
        dispatch(receiveRemoveQueueWaveMapping(queueEntityKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueEntityKey, [queueWaveMapping]);
  };
};
export var updateQueueOpeningHours = function updateQueueOpeningHours(queueKey, openingHours) {
  return function (dispatch) {
    QueuesResource.setOpeningHours({
      onResult: function onResult(json) {
        dispatch(receiveQueueOpeningHours(queueKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueKey, openingHours);
  };
};
export var fetchRefer = function fetchRefer(referKey) {
  return function (dispatch) {
    RefersResource.getRefer({
      onResult: function onResult(json) {
        dispatch(fetchReferCalendar(referKey));
        dispatch(receiveRefer(referKey, json));
      },
      onError: httpGetErrorDispatcher(dispatch)
    }, referKey, 'all,live', appFilter);
  };
};
export var fetchReferCalendar = function fetchReferCalendar(referKey) {
  return function (dispatch) {
    RefersResource.getCalendar({
      onResult: function onResult(json) {
        dispatch(receiveReferCalendar(referKey, json));
      },
      onError: httpGetErrorDispatcher(dispatch)
    }, referKey);
  };
};
export var fetchReferProfiles = function fetchReferProfiles(referKey) {
  return function (dispatch) {
    RefersResource.getProfiles({
      onResult: function onResult(json) {
        dispatch(receiveReferProfiles(referKey, json));
      },
      onError: httpGetErrorDispatcher(dispatch)
    }, referKey);
  };
};
export var updateRefer = function updateRefer(referKey, referDTO) {
  return function (dispatch) {
    var refer = _objectSpread(_objectSpread({}, referDTO), {}, {
      key: referKey
    });
    RefersResource.setRefer({
      onResult: function onResult(json) {
        dispatch(receiveRefer(referKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, refer);
  };
};
export var updateReferOpeningHours = function updateReferOpeningHours(referKey, openingHours) {
  return function (dispatch) {
    RefersResource.setOpeningHours({
      onResult: function onResult(json) {
        dispatch(receiveReferOpeningHours(referKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, referKey, openingHours);
  };
};
export var activateReferProfile = function activateReferProfile(referKey, profileDTO, callback) {
  return function (dispatch) {
    RefersResource.setActiveProfile({
      onResult: function onResult(json) {
        dispatch(receiveReferProfile(referKey, json));
        if (callback) {
          callback();
        }
      },
      onError: networkErrorDispatcher(dispatch)
    }, referKey, profileDTO);
  };
};
export var updateQueueCalendarEvent = function updateQueueCalendarEvent(entityKey, calendarEventKey, calendarEventDTO) {
  return function (dispatch) {
    QueuesResource.setEvent({
      onResult: function onResult(json) {
        dispatch(receiveQueueUpdateCalendarEvent(entityKey, calendarEventKey, json));
        dispatch(fetchQueue(entityKey));
      },
      onError: networkErrorDispatcher(dispatch)
    }, entityKey, calendarEventKey, calendarEventDTO);
  };
};
export var removeQueueCalendarEvent = function removeQueueCalendarEvent(entityKey, calendarEventKey) {
  return function (dispatch) {
    QueuesResource.deleteEvent({
      onResult: function onResult(json) {
        dispatch(receiveQueueRemoveCalendarEvent(entityKey, json));
        dispatch(fetchQueue(entityKey));
        dispatch(fetchQueueCalendar(entityKey));
      },
      onError: networkErrorDispatcher(dispatch)
    }, entityKey, calendarEventKey);
  };
};
export var createQueueCalendarEvent = function createQueueCalendarEvent(entityKey, calendarEvent) {
  return function (dispatch) {
    QueuesResource.addEvent({
      onResult: function onResult(json) {
        dispatch(receiveCreateQueueCalendarEvent(entityKey, json));
        dispatch(fetchQueue(entityKey));
      },
      onError: networkErrorDispatcher(dispatch)
    }, entityKey, calendarEvent);
  };
};
var receiveCreateQueueCalendarEvent = function receiveCreateQueueCalendarEvent(entityKey, calenderEventDTO) {
  return {
    type: Actions.RESULT_QUEUE_ADD_CALENDAR_EVENT,
    entityKey: entityKey,
    data: calenderEventDTO
  };
};
export var removeReferCalendarEvent = function removeReferCalendarEvent(entityKey, calendarEventKey) {
  return function (dispatch) {
    RefersResource.deleteEvent({
      onResult: function onResult(json) {
        dispatch(receiveReferRemoveCalendarEvent(entityKey, json));
        dispatch(fetchRefer(entityKey));
        dispatch(fetchReferCalendar(entityKey));
      },
      onError: networkErrorDispatcher(dispatch)
    }, entityKey, calendarEventKey);
  };
};
export var updateReferCalendarEvent = function updateReferCalendarEvent(entityKey, calendarEventKey, calendarEventDTO) {
  return function (dispatch) {
    RefersResource.setEvent({
      onResult: function onResult(json) {
        dispatch(receiveReferUpdateCalendarEvent(entityKey, calendarEventKey, json));
        dispatch(fetchRefer(entityKey));
      },
      onError: networkErrorDispatcher(dispatch)
    }, entityKey, calendarEventKey, calendarEventDTO);
  };
};
export var createReferCalendarEvent = function createReferCalendarEvent(entityKey, calendarEvent) {
  return function (dispatch) {
    RefersResource.addEvent({
      onResult: function onResult(json) {
        dispatch(receiveCreateReferCalendarEvent(entityKey, json));
        dispatch(fetchRefer(entityKey));
      },
      onError: networkErrorDispatcher(dispatch)
    }, entityKey, calendarEvent);
  };
};
export var updateQueueProfile = function updateQueueProfile(entityKey, profileKey, profileDTO) {
  return function (dispatch) {
    QueuesResource.updateQueueProfile({
      onResult: function onResult(json) {
        dispatch(receiveUpdateQueueProfile(entityKey, profileKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, entityKey, profileKey, profileDTO);
  };
};
export var fetchActiveOmniErrands = function fetchActiveOmniErrands(queueKey) {
  return function (dispatch) {
    QueuesResource.getActiveOmniTasks({
      onResult: function onResult(json) {
        dispatch(receiveActiveOmniErrands(queueKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, queueKey);
  };
};
export var receiveTopPbxVoiceMessage = function receiveTopPbxVoiceMessage(entityKey, voiceMessageDTO) {
  var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch) {
    dispatch(fetchSharedVoicemail(entityKey));
    if (!silent) {
      dispatch(spawnVoiceMessageNotification(voiceMessageDTO));
    }
  };
};
var receiveUpdateQueueProfile = function receiveUpdateQueueProfile(entityKey, profileKey, profileDTO) {
  return {
    type: Actions.RESULT_QUEUE_PROFILE_UPDATE,
    entityKey: entityKey,
    profileKey: profileKey,
    data: profileDTO
  };
};
var receiveCreateReferCalendarEvent = function receiveCreateReferCalendarEvent(entityKey, calenderEventDTO) {
  return {
    type: Actions.RESULT_REFER_ADD_CALENDAR_EVENT,
    entityKey: entityKey,
    data: calenderEventDTO
  };
};
export var fetchQueuesWithPromise = function fetchQueuesWithPromise(include) {
  return function (dispatch) {
    include = include ? "apps,contact,".concat(include) : 'apps,contact';
    return new Promise(function (resolve, reject) {
      QueuesResource.getSimpleQueues({
        onResult: function onResult(json) {
          dispatch(receiveQueues(json));
          resolve();
        },
        onClientError: function onClientError(/*error*/
        ) {
          reject();
        },
        onError: function onError(/**/
        ) {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, include, appFilter);
    });
  };
};
export var fetchQueues = function fetchQueues(include) {
  include = include ? "apps,contact,".concat(include) : 'apps,contact';
  return function (dispatch) {
    var cb = createCallback(dispatch, receiveQueues);
    QueuesResource.getSimpleQueues(cb, include, appFilter);
  };
};

// Lightweight variant that skips contact data (used for refreshing
// queue member login state on reconnection — existing contact data
// in the store is preserved via mergeDeep in the RESULT_QUEUES handler)
export var fetchQueuesWithoutContact = function fetchQueuesWithoutContact() {
  return function (dispatch) {
    var cb = createCallback(dispatch, receiveQueues);
    QueuesResource.getSimpleQueues(cb, 'apps', appFilter);
  };
};
export var reloadRefers = function reloadRefers() {
  return function (dispatch) {
    var cb = createCallback(dispatch, receiveRefers);
    RefersResource.getSimpleRefers(cb, 'apps', appFilter);
  };
};
export var fetchSharedVoicemail = function fetchSharedVoicemail(entityKey) {
  for (var _len = arguments.length, include = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    include[_key - 1] = arguments[_key];
  }
  return function (dispatch) {
    VoicemailsResource.getVoicemail({
      onResult: function onResult(json) {
        dispatch(receiveSharedVoicemail(entityKey, json));
      },
      onError: httpGetErrorDispatcher(dispatch)
    }, entityKey, include, appFilter);
  };
};
var reloadSharedVoicemails = function reloadSharedVoicemails() {
  return function (dispatch) {
    var cb = createCallback(dispatch, receiveSharedVoicemails);
    VoicemailsResource.getVoicemails(cb, 'contact,all', appFilter);
  };
};
export var updateSharedVoicemail = function updateSharedVoicemail(entityKey, voicemailDTO) {
  return function (dispatch) {
    VoicemailsResource.updateVoicemail({
      onResult: function onResult(json) {
        dispatch(receiveSharedVoicemail(entityKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, voicemailDTO);
  };
};
export var removeSharedVoiceMessage = function removeSharedVoiceMessage(entityKey, uniqueId) {
  return function (dispatch) {
    VoicemailsResource.removeVoiceMessage({
      onResult: function onResult() {
        dispatch(receiveVoiceMessageDelete(entityKey, uniqueId));
      } /*json*/,
      onError: networkErrorDispatcher(dispatch)
    }, entityKey, uniqueId);
  };
};
export var removeAllSharedVoiceMessages = function removeAllSharedVoiceMessages(entityKey) {
  return function (dispatch) {
    VoicemailsResource.removeAllVoiceMessages({
      onResult: function onResult() {
        dispatch(receiveVoiceMessageDeleteAll(entityKey));
      } /*json*/,
      onError: networkErrorDispatcher(dispatch)
    }, entityKey);
  };
};
export var setSharedVoiceMessageRead = function setSharedVoiceMessageRead(voicemailKey, voiceMessageUniqueID) {
  return function (dispatch) {
    dispatch(receiveSetSharedVoicemessageRead(voicemailKey, voiceMessageUniqueID));
  };
};
var receiveSetSharedVoicemessageRead = function receiveSetSharedVoicemessageRead(voicemailKey, voiceMessageUniqueID) {
  return {
    type: Actions.SET_SHARED_VOICEMESSAGE_READ,
    voicemailKey: voicemailKey,
    voiceMessageUniqueID: voiceMessageUniqueID
  };
};
var receiveSharedVoicemail = function receiveSharedVoicemail(entityKey, voicemailDTO) {
  return {
    type: Actions.RESULT_SHARED_VOICEMAIL,
    key: entityKey,
    data: voicemailDTO
  };
};
var receiveVoiceMessageDelete = function receiveVoiceMessageDelete(entityKey, uniqueId) {
  return {
    type: Actions.RESULT_SHARED_VOICEMESSAGE_DELETE,
    key: entityKey,
    data: {
      uniqueId: uniqueId
    }
  };
};
var receiveVoiceMessageDeleteAll = function receiveVoiceMessageDeleteAll(entityKey) {
  return {
    type: Actions.RESULT_SHARED_VOICEMESSAGES_DELETE_ALL,
    key: entityKey
  };
};
export var reloadConferences = function reloadConferences() {
  return function (dispatch) {
    var cb = createCallback(dispatch, receiveConferences);
    ConferencesResource.getConferences(cb, 'contact,live');
  };
};
var receiveQueues = function receiveQueues(json) {
  return function (dispatch, getState) {
    return dispatch({
      type: Actions.RESULT_QUEUES,
      data: json,
      ownExtensionKey: selectOwnExtensionKey(getState())
    });
  };
};
export var receiveQueueMemberUpdate = function receiveQueueMemberUpdate(queueKey, memberKey, json) {
  return {
    type: Actions.RESULT_QUEUE_MEMBER_UPDATE,
    queueKey: queueKey,
    memberKey: memberKey,
    data: json
  };
};
var receiveAddQueueMembers = function receiveAddQueueMembers(queueKey, json) {
  return function (dispatch, getState) {
    return dispatch({
      type: Actions.RESULT_ADD_QUEUE_MEMBERS,
      queueKey: queueKey,
      data: json,
      ownExtensionKey: selectOwnExtensionKey(getState())
    });
  };
};
var receiveAddQueueWaveMappings = function receiveAddQueueWaveMappings(queueKey, queueWaveKey, json) {
  return {
    type: Actions.RESULT_ADD_QUEUE_WAVE_MAPPINGS,
    queueKey: queueKey,
    queueWaveKey: queueWaveKey,
    data: json
  };
};
var receiveRemoveQueueMember = function receiveRemoveQueueMember(queueKey, json) {
  return function (dispatch, getState) {
    return dispatch({
      type: Actions.RESULT_REMOVE_QUEUE_MEMBERS,
      queueKey: queueKey,
      data: json,
      ownExtensionKey: selectOwnExtensionKey(getState())
    });
  };
};
var receiveRemoveQueueWaveMapping = function receiveRemoveQueueWaveMapping(queueKey, json) {
  return {
    type: Actions.RESULT_REMOVE_QUEUE_WAVE_MAPPING,
    queueKey: queueKey,
    data: json
  };
};
export var receiveQueueProfile = function receiveQueueProfile(queueKey, json) {
  return {
    type: Actions.RESULT_QUEUE_PROFILE,
    key: queueKey,
    data: json
  };
};
var receiveQueueOpeningHours = function receiveQueueOpeningHours(queueKey, json) {
  return {
    type: Actions.RESULT_QUEUE_OPENING_HOURS,
    key: queueKey,
    data: json
  };
};
var receiveQueueUpdateCalendarEvent = function receiveQueueUpdateCalendarEvent(entityKey, originalCalendarEventKey, calenderEventDTO) {
  return {
    type: Actions.RESULT_QUEUE_UPDATE_CALENDAR_EVENT,
    entityKey: entityKey,
    originalCalendarEventKey: originalCalendarEventKey,
    data: calenderEventDTO
  };
};
var receiveQueueRemoveCalendarEvent = function receiveQueueRemoveCalendarEvent(entityKey, calenderEventDTO) {
  return {
    type: Actions.RESULT_QUEUE_REMOVE_CALENDAR_EVENT,
    entityKey: entityKey,
    data: calenderEventDTO
  };
};
var receiveQueueCalendar = function receiveQueueCalendar(queueKey, json) {
  return {
    type: Actions.RESULT_QUEUE_CALENDAR,
    key: queueKey,
    data: json
  };
};
var receiveQueueStatSummary = function receiveQueueStatSummary(queueKey, json) {
  return {
    type: Actions.RESULT_QUEUE_STAT_SUMMARY,
    key: queueKey,
    data: json
  };
};
var receiveQueue = function receiveQueue(queueKey, json) {
  return {
    type: Actions.RESULT_QUEUE,
    key: queueKey,
    data: json
  };
};
var receiveAllowedQueueMembers = function receiveAllowedQueueMembers(queueKey, json) {
  return {
    type: Actions.RESULT_ALLOWED_QUEUE_MEMBERS,
    key: queueKey,
    data: json
  };
};
var receiveReferOpeningHours = function receiveReferOpeningHours(referKey, json) {
  return {
    type: Actions.RESULT_REFER_OPENING_HOURS,
    key: referKey,
    data: json
  };
};
var receiveReferUpdateCalendarEvent = function receiveReferUpdateCalendarEvent(entityKey, originalCalendarEventKey, calenderEventDTO) {
  return {
    type: Actions.RESULT_REFER_UPDATE_CALENDAR_EVENT,
    entityKey: entityKey,
    originalCalendarEventKey: originalCalendarEventKey,
    data: calenderEventDTO
  };
};
var receiveReferRemoveCalendarEvent = function receiveReferRemoveCalendarEvent(entityKey, calenderEventDTO) {
  return {
    type: Actions.RESULT_REFER_REMOVE_CALENDAR_EVENT,
    entityKey: entityKey,
    data: calenderEventDTO
  };
};
var receiveReferProfile = function receiveReferProfile(referKey, json) {
  return {
    type: Actions.RESULT_REFER_PROFILE,
    key: referKey,
    data: json
  };
};
var receiveRefers = function receiveRefers(json) {
  return {
    type: Actions.RESULT_REFERS,
    data: json
  };
};
var receiveRefer = function receiveRefer(referKey, json) {
  return {
    type: Actions.RESULT_REFER,
    key: referKey,
    data: json
  };
};
var receiveReferCalendar = function receiveReferCalendar(referKey, json) {
  return {
    type: Actions.RESULT_REFER_CALENDAR,
    key: referKey,
    data: json
  };
};
var receiveReferProfiles = function receiveReferProfiles(referKey, json) {
  return {
    type: Actions.RESULT_REFER_PROFILES,
    key: referKey,
    data: json
  };
};
var receiveSharedVoicemails = function receiveSharedVoicemails(json) {
  return {
    type: Actions.RESULT_SHARED_VOICEMAILS,
    data: json
  };
};
var receiveActiveOmniErrands = function receiveActiveOmniErrands(queueKey, json) {
  return {
    type: Actions.RESULT_ACTIVE_OMNI_ERRANDS,
    queue: queueKey,
    data: json
  };
};
export var updateConference = function updateConference(conferenceDTO) {
  return function (dispatch) {
    var conferenceKey = conferenceDTO.get('key');
    ConferencesResource.updateConference({
      onResult: function onResult(json) {
        dispatch(receiveConference(conferenceKey, json));
      },
      onError: networkErrorDispatcher(dispatch)
    }, conferenceKey, conferenceDTO);
  };
};
var receiveConference = function receiveConference(conferenceKey, json) {
  return {
    type: Actions.RESULT_CONFERENCE,
    key: conferenceKey,
    data: json
  };
};
var receiveConferences = function receiveConferences(json) {
  return {
    type: Actions.RESULT_CONFERENCES,
    data: json
  };
};
export var fetchSharedExtensions = function fetchSharedExtensions() {
  return function (dispatch) {
    SharedExtensionResource.getSharedExtensions({
      onResult: function onResult(json) {
        dispatch(receiveSharedExtensions(json));
      },
      onError: httpGetErrorDispatcher(dispatch)
    }, '', appFilter);
  };
};
var receiveSharedExtensions = function receiveSharedExtensions(json) {
  return {
    type: Actions.RESULT_SHARED_EXTENSION,
    data: json
  };
};
export { receiveQueue };
export var reloadPbx = function reloadPbx() {
  return function (dispatch) {
    dispatch(fetchQueues());
    dispatch(reloadRefers());
    dispatch(reloadSharedVoicemails());
    dispatch(fetchSharedExtensions());
    dispatch(fetchWidgetChannels('apps'));
  };
};
// TODO: WEB-14413 - Needed only because of GUI bug. Remove when voicemails can be fetched without admin flag.
export var reloadNonAdminPbx = function reloadNonAdminPbx() {
  return function (dispatch) {
    dispatch(fetchQueues());
    dispatch(reloadRefers());
    dispatch(fetchSharedExtensions());
    dispatch(fetchWidgetChannels('apps'));
  };
};